<script>
    export let updateBillingRulesPhase = () => {};
</script>

<div class="flex flex-col gap-y-4 p-6 w-full">
    <div class="flex flex-col gap-y-4">
        <div class="flex justify-center">
            <img src="/imgs/illi_1@2x.png" alt="img" />
        </div>

        <p class="text-[20px] font-bold">Creating Your Own Rules</p>

        <p class="text-[16px]">
            How do you normally bill? You might have a number of ways you bill
            depending on the case or patient. Anaemate allows you to create as
            many billing rules as you need. Just name the rule, enter the
            parameters, and start billing.
        </p>

        <p class="text-[16px]">
            One rule is your "Default rule", which Anaemate will use to
            prepopulate the billing selector. Anaemate also has two system
            billing rules you can use: "No Gap" which charges the patient no
            out-of-pocket amount, and "AMA rates" which charges the AMA
            recommended unit value.
        </p>

        <p class="text-[16px]">
            Worker's compensation, traffic accident claims, veteran and
            public-in-private bills are always charged as "No Gap". If you need
            to charge a gap, please contact Anaemate support.
        </p>
    </div>

    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-missing-content -->
    <div class="flex w-full justify-center">
        <div class="tabs flex gap-x-4 pb-4">
            <a
                class="tab tab-bordered cursor-pointer"
                on:click|preventDefault={updateBillingRulesPhase(1)}
            />
            <a
                class="tab tab-bordered cursor-pointer"
                on:click|preventDefault={updateBillingRulesPhase(2)}
            />
            <a class="tab tab-bordered tab-active cursor-default" />
            <a class="tab tab-bordered cursor-default" />
        </div>
    </div>

    <button
        class="btn btn-md btn-secondary"
        on:click|preventDefault={() => updateBillingRulesPhase(4)}
    >
        Next
    </button>
</div>

<style>
    img {
        width: 300px;
        height: 300px;
    }
</style>
